import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse, IconButton, Stack, Typography, FormControl, MenuItem } from "@mui/material";
import React, { useState } from "react";
import InvestmentProposalForm, { BulkConditionTarget } from "./InvestmentProposalForm";
import { InvestmentProposal } from "../../../../api/generated/src";
import { useTemplates } from "../../../../hooks/templates/useTemplates";
import Select from "../../../Atoms/Select";

interface CollapsibleInvestmentProposalProps {
  userIds?: number[];
  proposal?: InvestmentProposal; // 単数再提案の時はproposalを渡す
  isBulkReProposal?: boolean; // 一括再提案の時はtrue
  latestProposalDateForSingle?: string; // 個別再提案用にユーザーの最新提案日時を渡す
  latestProposalStatusForSingle?: string; // 上記日時が送信済み(sent)か送信予定(scheduled)か
  conditionTarget?: BulkConditionTarget; // 絞り込み条件で一括提案する時に渡す
}

export const CollapsibleInvestmentProposal: React.FC<CollapsibleInvestmentProposalProps> = ({
  userIds,
  proposal,
  isBulkReProposal,
  latestProposalDateForSingle,
  latestProposalStatusForSingle,
  conditionTarget,
}) => {
  const [open, setOpen] = useState(true);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>("");
  const { templates } = useTemplates();

  // 投資提案用のテンプレートのみフィルタリング
  const investmentTemplates = templates.filter((t) => t.template_type === "investment");

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Box>
      <Box
        sx={{
          p: "8px 16px",
          cursor: "pointer",
          backgroundColor: open ? "transparent" : "background.paper",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
        onClick={handleToggle}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography fontSize={18} fontWeight="bold" color="text.primary">
              {isBulkReProposal ? "投資再提案" : "投資提案"}
            </Typography>
            {open && (
              <FormControl size="small">
                <Select
                  value={selectedTemplateId}
                  onChange={(e) => setSelectedTemplateId(e.target.value as string)}
                  displayEmpty
                  renderValue={(value) => {
                    if (!value) {
                      return <span style={{ color: "#999" }}>テンプレートを選択</span>;
                    }
                    const template = investmentTemplates.find((t) => String(t.id) === value);
                    return template?.title || "";
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <MenuItem value="">
                    <em>テンプレートを選択</em>
                  </MenuItem>
                  {investmentTemplates.map((template) => (
                    <MenuItem key={template.id} value={String(template.id)}>
                      {template.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Stack>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Stack>
      </Box>

      <Collapse in={open}>
        <Box sx={{ padding: "8px 16px 16px" }}>
          <InvestmentProposalForm
            userIds={userIds}
            proposal={proposal}
            selectedTemplateId={selectedTemplateId}
            templates={investmentTemplates}
            isBulkReProposal={isBulkReProposal}
            latestProposalDateForSingle={latestProposalDateForSingle}
            latestProposalStatusForSingle={latestProposalStatusForSingle}
            conditionTarget={conditionTarget}
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleInvestmentProposal;
